import { render, staticRenderFns } from "./ShopRiskLogs.vue?vue&type=template&id=f67e222c&scoped=true"
import script from "./ShopRiskLogs.vue?vue&type=script&lang=ts"
export * from "./ShopRiskLogs.vue?vue&type=script&lang=ts"
import style0 from "./ShopRiskLogs.vue?vue&type=style&index=0&id=f67e222c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67e222c",
  null
  
)

export default component.exports